<template>
  <SplashComponent />
</template>

<script>
import SplashComponent from "../components/appComponent/SplashComponent.vue";

export default {
  components: { SplashComponent },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
